module.exports = __webpack_public_path__ + "img/17.b2b7875d.jpg";